import React, { FC, useEffect, useRef } from 'react';
import { ICTask } from '../../../helper/Interfaces';
import editClasses from '../EditTextField/EditTextField.module.css';

type EditTextFieldProps = {
  value: string;
  setValue: (value: string) => void;
  task: ICTask;
  handleClick: () => void;
  classes?: string[];
  isActive: boolean;
  updateTaskName?: (currentTask: ICTask, taskName: string) => void;
  updateSection?: (currentSectionId: string, sectionName: string) => void;
  setIsActive?: (isActive: boolean) => void;
  editOnClick?: boolean;
  style?: any;
  dotView?: boolean;
  disabled?: boolean;
};

const EditTextField: FC<EditTextFieldProps> = ({
  value,
  setValue,
  handleClick,
  task,
  classes,
  isActive,
  updateTaskName,
  updateSection,
  setIsActive,
  editOnClick,
  style,
  dotView,
  disabled,
}) => {
  const inputReference = useRef<HTMLInputElement>(null);
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isActive) {
      setTimeout(() => {
        inputReference.current?.focus();
      }, 200);
    }
  }, [isActive]);

  const updateTaskWidth = () => {
    if (value && value?.length > 50) {
      return 'task-name-content';
    }
    return '';
  };

  const isDisabled = () => {
    if (disabled) {
      return;
    }
    setIsActive && setIsActive(false);
    setTimeout(() => {
      inputReference.current?.focus();
    }, 200);
  };

  const handleClickOutside = (event: any) => {
    if (container.current && !container.current.contains(event.target)) {
      setIsActive && setIsActive(false);
      if (task.name !== value) {
        handleClick();
        if (updateTaskName) updateTaskName(task, value);
        if (updateSection) updateSection(task.id ?? '', value);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      // clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  return (
    <div
      className={classes ? ['Subtitle-1', ...classes].join(' ') : 'Subtitle-1'}
      style={style}
      onDoubleClick={() => isDisabled()}
      ref={container}
    >
      {isActive ? (
        <input
          ref={inputReference}
          value={value}
          className={editClasses.setNameEdit}
          style={{
            width:
              value.length > 8
                ? value.length * 10
                : value.length * 14 > 450
                ? 450
                : value.length * 14,
          }}
          onChange={e => setValue(e.target.value)}
          autoFocus={isActive}
          onBlur={event => {
            handleClick();
            if (updateTaskName) updateTaskName(task, value);
            if (updateSection) updateSection(task.id ?? '', value);
            //if (setIsActive) setIsActive(false);
          }}
          onKeyDown={event => {
            if (event.key === 'Enter' || event.key === 'Escape') {
              handleClick();
              event.preventDefault();
              event.stopPropagation();
              if (updateTaskName) updateTaskName(task, value);

              if (updateSection) updateSection(task.id ?? '', value);
              if (setIsActive) setIsActive(false);
            }
          }}
          disabled={disabled}
        />
      ) : (
        <span
          title={value}
          onClick={() => {
            if (editOnClick && setIsActive) {
              setIsActive(true);
            }
          }}
          style={{
            maxWidth:
              task &&
              ['subtask', 'risk', 'issue', 'decision'].includes(task.type ?? '')
                ? '17.625rem'
                : '28.625rem',
          }}
          className={[
            'task-title',
            classes?.includes('section-name') ? 'section-name' : '',
            dotView ? 'dot-view' : updateTaskName ? 'dot-list-view' : '',
            updateTaskWidth(),
          ].join(' ')}
        >
          {value}
        </span>
      )}
    </div>
  );
};

export default EditTextField;
